import Tooltip from "../../Tooltip";
import { ChromeIcon } from "../../SVGs/MainMenuIcons";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    "& *": {
      padding: "0.1rem",
      fontSize: "1rem",
      color: "rgb(131 131 131)",
    },
    "& svg": {
      width: "33px",
      height: "33px",
    },
    "@media only screen and (max-width: 992px)": {
      display: "none",
    },
  },
});

const isChrome =
  /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

const ChromeLink = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const isInstalled = false;
  return isChrome && !isInstalled ? (
    <Tooltip
      title={
        <span
          style={{ fontSize: "1rem", textAlign: "center", display: "flex" }}
        >
          {t("Install Abjadiyat Extension")}
        </span>
      }
    >
      <a
        target="_blank"
        rel="noopener noreferrer"
        className={classes.root}
        href="https://chrome.google.com/webstore/detail/abjadiyat-web-player/ngjblgfbdencjbjbpcekbcjjhcgibejg"
      >
        <ChromeIcon />
      </a>
    </Tooltip>
  ) : null;
};

export default ChromeLink;
